export const QUERY_VALUE_DELIMITER = ".~_";
